import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import type { FC } from "react";

import { useStyles } from "./ExportSubscribeButton.styles";
import { messages } from "./ExportSubscribeButton.messages";
import { FormattedMessage, useIntl } from "react-intl";
import { AddSubscriptionDialog } from "../../../subscriptions/components";
import { SubscriptionItemType } from "../../../subscriptions/types";
import { IBulkExportContextState, useBulkExportContext, useSubscriptionProviderContext } from "../../providers";

export const ExportSubscribeButton: FC = () => {
  const classes = useStyles();
  const { formatMessage } = useIntl();

  const {
    state: { currentPayload, isSubscriptionLoading, isSubscriptionDisabled },
  } = useSubscriptionProviderContext();
  const context = useBulkExportContext();
  const { tab } = context?.state as IBulkExportContextState;

  const [addSubscriptionDialogOpen, setAddSubscriptionDialog] = useState(false);

  const formattedTitle = formatMessage(messages.subscribeButton);
  return (
    <>
      {currentPayload && tab === 0 && "dimensions" in currentPayload && (
        <AddSubscriptionDialog
          type={SubscriptionItemType.BulkExport}
          payload={currentPayload!}
          open={addSubscriptionDialogOpen}
          handleCloseDialog={() => setAddSubscriptionDialog(false)}
        />
      )}
      {currentPayload && tab === 1 && "savedSettingId" in currentPayload && (
        <AddSubscriptionDialog
          type={SubscriptionItemType.SavedBulkExport}
          payload={currentPayload!}
          open={addSubscriptionDialogOpen}
          handleCloseDialog={() => setAddSubscriptionDialog(false)}
        />
      )}

      <Button
        color="primary"
        variant="contained"
        title={formattedTitle}
        onClick={() => setAddSubscriptionDialog(true)}
        classes={classes}
        disabled={isSubscriptionDisabled || isSubscriptionLoading}
      >
        <FormattedMessage {...messages.subscribeButton} />
      </Button>
    </>
  );
};
